import { render } from "./ThankYou.vue?vue&type=template&id=4784f664&scoped=true"
const script = {}

import "./ThankYou.vue?vue&type=style&index=0&id=4784f664&scoped=true&lang=css"

import exportComponent from "/home/devops/vsts-agent/_work/20/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4784f664"]])

export default __exports__